// extracted by mini-css-extract-plugin
export default {"SizeAuto":"_SizeAuto--uhCet","FluidHeight":"_FluidHeight--ZkHMt"};